module.exports = __webpack_public_path__ + "static/media/remoteAccess.40bfd57c.png";